// extracted by mini-css-extract-plugin
module.exports = {"success_msg":"index_success_msg__gc3EQ"};